import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const JSnapshotComponent = ({jsnapshot}) => { 
    if (!jsnapshot || !jsnapshot.snapshots) {
        return '';
    }
    return (
        <div className="jsnapshot">
          <div onClick={() => jsnapshot.takeSnapshot()} className="take-snapshot-btn">
            Save
          </div>
          <div className="snapshots">
        {jsnapshot.snapshots.map(
            (x,i) => <div
                       onClick={() => jsnapshot.useSnapshot(i)}
                       className="snapshot-option">{i+1}</div>)}
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      snapshots: props.jsnapshot && props.jsnapshot.snapshots
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JSnapshotComponent);
